import React from 'react'
import Hero from '../Components/Hero/Hero'

const Shop = () => {
  return (
    <div>
      <Hero />
    </div>
  )
}

export default Shop